export const tags = [
  { slug: "hot", name: "热门", description: "近期热度最高的精彩视频，不可错过的热门推荐。" },
  { slug: "funny", name: "搞笑", description: "轻松搞笑的视频合集，忙碌之余给自己一点欢乐。" },
  { slug: "original", name: "原创", description: "平台原创与创作者自制的独家视频内容。" },
  { slug: "hd", name: "4K高清", description: "支持 4K 高清画质播放的视频，细节清晰可见。" },
  { slug: "short", name: "短视频", description: "节奏明快的短视频，碎片时间也能畅快观看。" },
  { slug: "documentary", name: "纪录片", description: "深度纪实与自然人文纪录片，看见更广阔的世界。" },
  { slug: "tutorial", name: "教程", description: "实用教程与技能教学，跟着视频一步步学会。" },
  { slug: "family", name: "亲子", description: "适合与孩子一起观看的亲子与动画内容。" },
  { slug: "cooking", name: "美食制作", description: "从食材到成品的美食制作全过程。" },
  { slug: "pets", name: "萌宠", description: "可爱萌宠的日常瞬间，治愈你的每一天。" },
];